import isEmpty from 'lodash/isEmpty';

export default function collectKpi(campaign) {
  const targetKpi = !isEmpty(campaign.targetKpi)
    ? campaign.targetKpi
    : campaign.quote.targetKpi;

  const targetKpiValue = campaign.targetKpiValue
    ? campaign.targetKpiValue
    : campaign.quote.targetKpiValue;

  return { targetKpi, targetKpiValue };
}
